var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91699 0.580078C9.6709 0.580078 12.1904 2.48438 12.1904 5.38477C12.1904 8.10938 10.7842 11.1562 7.67871 11.1562C6.91699 11.1562 6.00879 10.7754 5.62793 10.1016C4.9834 12.7383 5.0127 13.1484 3.54785 15.1699C3.40137 15.2285 3.43066 15.2285 3.34277 15.1113C3.28418 14.5547 3.22559 14.0273 3.22559 13.4707C3.22559 11.6836 4.0459 9.07617 4.45605 7.34766C4.22168 6.87891 4.16309 6.35156 4.16309 5.85352C4.16309 3.50977 6.91699 3.1582 6.91699 5.0918C6.91699 6.23438 6.12598 7.31836 6.12598 8.43164C6.12598 9.16406 6.77051 9.69141 7.50293 9.69141C9.52441 9.69141 10.1396 6.79102 10.1396 5.23828C10.1396 3.1582 8.6748 2.01562 6.65332 2.01562C4.33887 2.01562 2.55176 3.68555 2.55176 6.0293C2.55176 7.17188 3.25488 7.75781 3.25488 8.02148C3.25488 8.25586 3.0791 9.04688 2.78613 9.04688C2.08301 9.04688 0.94043 7.875 0.94043 5.82422C0.94043 2.57227 3.89941 0.580078 6.91699 0.580078Z",
    fill: "#ED445E"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/wMbgHkRz2SmeuHAQ8J7z4k?node-id=66-483"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: -1.125,
    width: 11.25,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink3);
export default __webpack_public_path__ + "static/media/Link-3.bbfcca1ff242439895996bcae1d94a7d.svg";
export { ForwardRef as ReactComponent };